<!-- Add edit product Grid -->
<div class="offcanvas-header">
  <div class="offcanvas-header-wrapper">
    <h5 class="mb-0 offcanvas-title" id="offcanvasRightLabel">
      {{ createProductRequest.id > 0 ? "Update Product" : "Add Product" }}
    </h5>
    <button
      #closeAccrBtn
      type="button"
      class="btn-close"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
</div>
<div class="offcanvas-body p-0" style="height: calc(100vh - 150px)">
  <div class="canvas-body-wrapper">
    <div class="progress-section">
      <ul class="progressbar">
        <li
          *ngFor="let step of stepsFeildArray; let i = index"
          [ngStyle]="{
            '--bar-color': tabIndex > i + 1 ? '#175F91' : '#DFDFDF'
          }"
        >
          <div>
            <div
              class="progress-dot"
              style="flex-basis: 10%"
              [id]="'progressDot' + i"
              [hidden]="tabIndex > i + 1"
              [style.border]="
                tabIndex == i + 1 ? '1px solid #175f91' : '1px solid #DFDFDF'
              "
              [style.boxShadow]="
                tabIndex == i + 1 ? '0px 0px 4px 5px #175F9145' : 'none'
              "
            >
              <p
                [style.background]="tabIndex == i + 1 ? '#175F91' : '#DFDFDF'"
              ></p>
            </div>
            <div
              class="progress-dot"
              style="flex-basis: 10%"
              [id]="'progressDot' + i"
              *ngIf="tabIndex > i + 1"
            >
              <img src="../../../../../assets/Icons/_StepBaseItem.svg" />
            </div>
          </div>
          <div>
            <small style="color: #475569">Step {{ step.id }}</small>
            <p
              class="progress-head"
              [style.color]="tabIndex < i + 1 ? '#475569' : 'black'"
            >
              {{ step.name }}
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="main-content h-100">
      <div class="tab-wrapper h-100">
        <!-- Tab 1 Content -->
        <div class="tab tab-1" *ngIf="tabIndex == 1" #tab1>
          <div
            class="d-flex align-items-center"
            style="height: 85px; padding-right: 26px"
          >
            <div class="tab-5-header tab-cm-header py-3">
              <h6>General Information</h6>
            </div>
          </div>
          <div
            *ngIf="!isLoading"
            #tab1Scroller
            style="
              height: calc(100% - 98px);
              overflow-y: scroll;
              padding-right: 26px;
            "
          >
            <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
            >
              <div class="enter">
                <label for="productName" class="form-label"
                  >Name<span class="rq-field">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="productName"
                  [(ngModel)]="createProductRequest.name"
                  placeholder="Enter product name"
                />
              </div>
              <div class="enter">
                <label for="productCondition" class="form-label"
                  >Product Condition<span class="rq-field">*</span></label
                >
                <select
                  class="form-select"
                  [(ngModel)]="createProductRequest.listerProduct.condition"
                  aria-label="Default select example"
                  id="productCondition"
                >
                  <option [ngValue]="0" hidden>Select product condition</option>
                  <option
                    *ngFor="let item of conditionEnumList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
            >
              <div class="enter">
                <label for="productDescr" class="form-label"
                  >Description<span class="rq-field">*</span></label
                >
                <textarea
                  class="form-control"
                  name="productDescr"
                  [(ngModel)]="createProductRequest.description"
                  placeholder="Enter the product description"
                ></textarea>
              </div>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
            >
              <div class="enter">
                <label for="productCategory" class="form-label"
                  >Product Department<span class="rq-field">*</span></label
                >
                <select
                  class="form-select"
                  [(ngModel)]="createProductRequest.productDepartmentId"
                  aria-label="Default select example"
                  id="productCategory"
                  (change)="getCategoriesListAsync()"
                >
                  <option [ngValue]="null" hidden>Select Department</option>
                  <option
                    *ngFor="let item of departmentsList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="enter">
                <label for="brandName" class="form-label"
                  >Brand<span class="rq-field">*</span></label
                >
                <select
                  class="form-select"
                  [(ngModel)]="createProductRequest.brandId"
                  aria-label="Default select example"
                  id="brandName"
                >
                  <option [ngValue]="null" hidden>Select brand</option>
                  <option *ngFor="let item of brandsList" [ngValue]="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
            >
              <div class="enter">
                <label for="modelField" class="form-label">Model</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="createProductRequest.model"
                  id="modelField"
                  placeholder="Enter model name/number"
                />
              </div>
              <div class="enter">
                <label for="productCategory" class="form-label"
                  >Product Category<span class="rq-field">*</span></label
                >
                <select
                  class="form-select"
                  [(ngModel)]="createProductRequest.categoryId"
                  aria-label="Default select example"
                  id="productCategory"
                >
                  <option [ngValue]="null" hidden>Select Category</option>
                  <option
                    *ngFor="let item of categoriesList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <!-- <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
            >
              <div class="enter">
                <label for="supplyType" class="form-label"
                  >Supply Type<span class="rq-field">*</span></label
                >
                <select
                  class="form-select"
                  [(ngModel)]="createProductRequest.listerProduct.supplyType"
                  aria-label="Default select example"
                  id="supplyTypeField"
                  (change)="selectedSupplyType($event)"
                >
                  <option [ngValue]="null" hidden>Select Type</option>
                  <option
                    *ngFor="let item of supplyTypeEnumList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="enter">
                <label for="supplierField" class="form-label">
                  Select Supplier @if(productSupplyType.DonatedGoods !=
                  createProductRequest.listerProduct.supplyType){
                  <span class="rq-field">* </span>
                  }
                </label>
                <select
                  class="form-select"
                  [(ngModel)]="createProductRequest.supplierId"
                  aria-label="Default select example"
                  id="supplierField"
                  [disabled]="
                    productSupplyType.DonatedGoods ==
                    createProductRequest.listerProduct.supplyType
                  "
                >
                  <option [ngValue]="null" hidden>Select Supplier</option>
                  <option
                    *ngFor="let item of suppliersList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div> -->
            <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
            >
              <div class="enter">
                <label for="manufacturerField" class="form-label"
                  >Manufacturer<span class="rq-field">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="createProductRequest.manufacturer"
                  id="serialNumber"
                  placeholder="Enter manufacturer"
                />
              </div>
              <div class="enter">
                <label for="manufacturerField" class="form-label"
                  >Production Station <span class="rq-field">*</span></label
                >
                <select
                  class="form-select"
                  [(ngModel)]="createProductRequest.warehouseLocationId"
                  aria-label="Default select example"
                  id="warehouseLocation"
                >
                  <option [ngValue]="null" disabled selected>
                    Select warehouse location
                  </option>
                  <option
                    *ngFor="let item of warehouseLocationList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
            >
              <div class="enter">
                <div class="toggle-wrapper mt-2">
                  <span class="ms-2 form-label">Fragile </span>
                  <label class="switch">
                    <input
                      type="checkbox"
                      id="toggleSwitch"
                      name="canOverrideFloorPrice"
                      [checked]="createProductRequest.isFragile"
                      [(ngModel)]="createProductRequest.isFragile"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>

              <div class="enter"></div>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
              *ngIf="createProductRequest.id != 0"
            >
              <div class="enter">
                <label for="manufacturerField" class="form-label">Status</label>
                <select
                  class="form-select"
                  [(ngModel)]="createProductRequest.status"
                  aria-label="Default select example"
                  id="warehouseLocation"
                >
                  <option [ngValue]="0" hidden>Select product status</option>
                  <option
                    *ngFor="let statusItem of productStatusEnumList"
                    [ngValue]="statusItem.id"
                  >
                    {{ statusItem.name }}
                  </option>
                </select>
              </div>
              <div class="enter">
                <label for="brandName" class="form-label"
                  >Product Serial No</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="productDepartment"
                  [(ngModel)]="createProductRequest.serialNumber"
                  disabled="true"
                />
              </div>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center gap-3"
            >
              <div class="enter">
                <label for="note" class="form-label">Note</label>
                <textarea
                  class="form-control"
                  [(ngModel)]="createProductRequest.notes"
                  name="note"
                  placeholder="Enter note here ..."
                ></textarea>
              </div>
              <div class="enter">
                <label for="note" class="form-label"
                  >Posting Description <span class="rq-field">*</span></label
                >
                <textarea
                  class="form-control"
                  [(ngModel)]="
                    createProductRequest.listerProduct.postingDescription
                  "
                  name="note"
                  placeholder="Enter Posting Description here ..."
                ></textarea>
              </div>
            </div>
          </div>
          <!-- Loader -->
          <div
            *ngIf="isLoading"
            class="d-flex justify-content-center align-items-center"
            style="min-height: 200px"
          >
            <div class="spinner-border text-primary" role="status"></div>
          </div>
        </div>
        <!-- Tab 2 Content -->
        <div class="tab tab-2 h-100" *ngIf="tabIndex == 2">
          <div
            class="d-flex align-items-center"
            style="height: 72px; padding-right: 26px; padding-top: 18px"
          >
            <div class="tab-cm-header py-3">
              <h6>Posting Profile</h6>
            </div>
          </div>
          <div
            class="w-100 d-flex justify-content-between align-items-center"
            style="height: 112px; padding-right: 26px"
          >
            <div class="enter me-2 mb-0">
              <label for="postingProfile" class="form-label"
                >Posting Profile*</label
              >
              <div class="dropdown">
                <button
                  class="btn dropdown-toggle justify-content-start position-relative"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style="padding: 10px 14px; min-width: 325px"
                  [style.borderColor]="
                    createProductRequest.listerProduct.postingProfileId
                      ? '#888888'
                      : '#D4D4D4'
                  "
                >
                  {{
                    getPostingProfleName(
                      createProductRequest.listerProduct.postingProfileId
                    )
                  }}
                </button>
                <ul class="dropdown-menu px-2 pb-2" style="min-width: 325px">
                  <div class="input-cst">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search profile..."
                      [(ngModel)]="searchPostingProfileText"
                      (ngModelChange)="filterProfiles()"
                      style="height: 44px"
                    />
                  </div>
                  <li
                    class="pb-2 c-pt"
                    *ngFor="let item of filteredPostingProfiles"
                  >
                    <a
                      class="dropdown-item"
                      (click)="setPostingProfile(item.id)"
                    >
                      {{ item.name }}
                    </a>
                  </li>
                  <li
                    *ngIf="filteredPostingProfiles.length === 0"
                    class="p-2 text-muted"
                  >
                    No results found
                  </li>
                </ul>
              </div>
            </div>
            <div class="enter ms-2 mb-3"></div>
          </div>
          <div
            class="row profile-rules-wrapper"
            style="height: calc(100% - (112px + 72px))"
            *ngIf="postingProfile.id !== 0"
          >
            <div class="col-lg-5 cm-col h-100">
              <div class="col-wrapper h-100">
                <div class="cm-section-header">
                  <h6 class="mb-0">Posting Profile</h6>
                  <h6 class="mb-0">
                    Status :
                    <span style="color: #0070b9">{{
                      postingProfile.statusName
                    }}</span>
                  </h6>
                </div>
                <div class="cm-grp">
                  <div class="row mx-0">
                    <div class="col-12 cm-sm-col">
                      <label>Name</label>
                      <h6>{{ postingProfile.name }}</h6>
                    </div>
                    <div class="col-12 cm-sm-col pb-5">
                      <label>Description</label>
                      <h6>
                        {{ postingProfile.description | slice : 0 : 60 }}
                        <span *ngIf="postingProfile.description.length > 60">
                          ...
                        </span>
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Repeat Posting Profile</label>
                      <h6>
                        {{ postingProfile.repeatNoOfTimesIfUnsold }}
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Unpaid Auction Handling</label>
                      <h6>
                        {{ postingProfile.auctionPaymentDueOptionName }}
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Handling Price</label>
                      <div
                        class="custom-dropdown"
                        style="border-color: #888888 !important"
                        *ngIf="postingProfile.canOverrideHandlingCharges"
                      >
                        <span>$</span>
                        <input
                          typpe="text"
                          [(ngModel)]="postingProfile.handlingCharges"
                          class="form-control ps-0"
                        />
                      </div>
                      <div
                        class="custom-dropdown"
                        *ngIf="!postingProfile.canOverrideHandlingCharges"
                        style="border-color: #e1d0d0; color: #d2c7c7"
                      >
                        {{ postingProfile.handlingCharges | currency }}
                      </div>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>End of Rule Auction</label>
                      <h6>
                        {{ postingProfile.endOfAuctionActionName }}
                      </h6>
                    </div>
                    <div
                      class="col-xl-6 cm-sm-col"
                      *ngIf="
                        postingProfile.endOfAuctionActionName ==
                        'Move to Sales Floor'
                      "
                    >
                      <label>Sales Floor Price</label>
                      <div
                        class="custom-dropdown"
                        style="border-color: #888888 !important"
                        *ngIf="postingProfile.canOverrideFloorPrice"
                      >
                        <span>$</span>
                        <input
                          typpe="text"
                          [(ngModel)]="postingProfile.salesFloorPrice"
                          class="form-control ps-0"
                        />
                      </div>
                      <div
                        class="custom-dropdown"
                        *ngIf="!postingProfile.canOverrideFloorPrice"
                        style="border-color: #e1d0d0; color: #d2c7c7"
                      >
                        {{ postingProfile.salesFloorPrice | currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-7 cm-col h-100">
              <div class="col-wrapper h-100">
                <div class="cm-section-header">
                  <h6 class="mb-0">Posting Rules</h6>
                </div>
                <div class="accr-wrapper" id="rulesWrapperParent">
                  <div
                    class="ms-1 accordion mb-4"
                    [id]="'rule' + i + 1"
                    *ngFor="let ruleItem of postingProfile.rules; let i = index"
                  >
                    <div class="accordion-item">
                      <h2
                        class="accordion-header"
                        [id]="'ruleHeader' + (i + 1)"
                      >
                        <button
                          class="accordion-button d-flex align-items-center"
                          type="button"
                          data-bs-toggle="collapse"
                          [attr.data-bs-target]="
                            '#collapseSelectRule' + (i + 1)
                          "
                          [attr.aria-controls]="'collapseSelectRule' + (i + 1)"
                          aria-expanded="true"
                        >
                          <span>Rule {{ i + 1 }}</span>
                        </button>
                      </h2>
                      <div
                        [id]="'collapseSelectRule' + (i + 1)"
                        class="accordion-collapse collapse show"
                        [attr.aria-labelledby]="'ruleHeader' + (i + 1)"
                        data-bs-parent="#rulesWrapperParent"
                      >
                        <div class="pt-2 px-2">
                          <div class="cm-grp">
                            <div class="row mx-0">
                              <div class="col-12 cm-sm-col">
                                <label>Rule Type</label>
                                <h6>
                                  {{ ruleItem.typeName }}
                                </h6>
                              </div>
                              <div class="col-xl-4 cm-sm-col">
                                <label>Marketplace </label>
                                <h6>
                                  {{ ruleItem.marketplaceName }}
                                </h6>
                              </div>
                              <div class="col-xl-4 cm-sm-col">
                                <label>Marketplace Account</label>
                                <h6>
                                  {{ ruleItem.marketplaceAccount.name }}
                                </h6>
                              </div>
                              <div class="col-xl-4 cm-sm-col">
                                <label>Start</label>
                                <h6>
                                  {{ ruleItem.auctionStartOptionName }}
                                </h6>
                              </div>
                              <div class="col-xl-4 cm-sm-col">
                                <label>Duration (in days)</label>
                                <h6>{{ ruleItem.auctionDurationInDays }}</h6>
                              </div>
                              <div class="col-xl-4 cm-sm-col">
                                <label for="carrierField">Carrier</label>
                                <select
                                  class="form-select"
                                  [(ngModel)]="ruleItem.carrierId"
                                  aria-label="Default select example"
                                  id="carrierField"
                                  style="border-color: #8c8383"
                                  *ngIf="ruleItem.canOverrideCarrier"
                                >
                                  <option [ngValue]="0" hidden>
                                    Select carrier
                                  </option>
                                  <option
                                    *ngFor="let item of carriersList"
                                    [ngValue]="item.id"
                                  >
                                    {{ item.name }}
                                  </option>
                                </select>
                                <span
                                  class="d-block"
                                  *ngIf="!ruleItem.canOverrideCarrier"
                                >
                                  {{ getCarrierName(ruleItem.carrierId) }}</span
                                >
                              </div>
                              <div
                                class="col-xl-6 cm-sm-col"
                                *ngIf="ruleItem.typeName == 'BuyNow'"
                              >
                                <label>Price</label>
                                <div
                                  class="custom-dropdown"
                                  *ngIf="ruleItem.canOverrideBuyNowPrice"
                                >
                                  <span>$</span>
                                  <input
                                    typpe="text"
                                    [(ngModel)]="ruleItem.buyNowPrice"
                                    class="form-control"
                                  />
                                </div>
                                <div
                                  class="custom-dropdown"
                                  *ngIf="!ruleItem.canOverrideBuyNowPrice"
                                  style="border-color: #e1d0d0; color: #d2c7c7"
                                >
                                  {{ ruleItem.buyNowPrice | currency }}
                                </div>
                              </div>
                              <div *ngIf="ruleItem.typeName == 'Auction'">
                                <div class="col-xl-4 cm-sm-col">
                                  <label>Start Bid</label>
                                  <div
                                    class="custom-dropdown"
                                    style="border: 1px solid #888888 !important"
                                    *ngIf="ruleItem.canOverrideStartingBid"
                                  >
                                    <span>$</span>
                                    <input
                                      typpe="text"
                                      [(ngModel)]="ruleItem.startingBid"
                                      class="form-control"
                                    />
                                  </div>
                                  <div
                                    class="custom-dropdown"
                                    *ngIf="!ruleItem.canOverrideStartingBid"
                                    style="
                                      border-color: #e1d0d0;
                                      color: #d2c7c7;
                                    "
                                  >
                                    {{ ruleItem.startingBid | currency }}
                                  </div>
                                </div>
                                <div class="col-xl-4 cm-sm-col">
                                  <label>Bid Increment</label>
                                  <div
                                    class="custom-dropdown"
                                    style="border: 1px solid #888888 !important"
                                    *ngIf="ruleItem.canOverrideBidIncrement"
                                  >
                                    <span>$</span>
                                    <input
                                      typpe="text"
                                      [(ngModel)]="ruleItem.bidIncrement"
                                      class="form-control"
                                    />
                                  </div>
                                  <div
                                    class="custom-dropdown"
                                    *ngIf="!ruleItem.canOverrideBidIncrement"
                                    style="
                                      border-color: #e1d0d0;
                                      color: #d2c7c7;
                                    "
                                  >
                                    {{ ruleItem.bidIncrement | currency }}
                                  </div>
                                </div>
                                <div class="col-xl-4 cm-sm-col">
                                  <label>Reserve Price</label>
                                  <div
                                    class="custom-dropdown"
                                    style="border: 1px solid #888888 !important"
                                    *ngIf="ruleItem.canOverrideReservePrice"
                                  >
                                    <span>$</span>
                                    <input
                                      typpe="text"
                                      [(ngModel)]="ruleItem.reservePrice"
                                      class="form-control"
                                    />
                                  </div>
                                  <div
                                    class="custom-dropdown"
                                    *ngIf="!ruleItem.canOverrideReservePrice"
                                    style="
                                      border-color: #e1d0d0;
                                      color: #d2c7c7;
                                    "
                                  >
                                    {{ ruleItem.reservePrice | currency }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Tab 3 Content -->
        <div class="tab tab-3 h-100" *ngIf="tabIndex == 3">
          <div
            class="d-flex align-items-center"
            style="height: 100px; padding-right: 26px"
          >
            <div class="tab-3-header tab-cm-header">
              <h6>Attributes</h6>
              <div class="d-flex align-items-center">
                <input
                  type="text"
                  class="form-control py-1"
                  [(ngModel)]="createAttributeName"
                  (keyup.enter)="addAttribute()"
                  placeholder="Type attribute name..."
                />
                <button class="btn ms-3" (click)="addAttribute()">Add</button>
              </div>
            </div>
          </div>
          <div class="tab-3-fileds-wrapper">
            <div
              class="field-head mt-0"
              *ngIf="createProductRequest.attributes.length > 0"
            >
              <h6 class="mb-0">Product</h6>
            </div>
            <div class="row">
              <div
                class="col-6 mb-3"
                *ngFor="let item of visibleProductAttributes; let i = index"
              >
                <label class="form-label">
                  {{ item.name }} <span class="rq-field">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="item.value"
                  placeholder="Enter {{ item.name | lowercase }}"
                />
              </div>
            </div>
            <div
              class="field-head mt-0"
              *ngIf="
                createProductRequest.listerProduct.marketplaceAttributes
                  .length > 0
              "
            >
              <h6 class="mb-0">Marketplace</h6>
            </div>
            <div class="row">
              <div
                class="col-md-6 enter w-50"
                *ngFor="
                  let item of createProductRequest.listerProduct
                    .marketplaceAttributes;
                  let i = index
                "
              >
                <label [for]="'attrInputField' + (i + 1)" class="form-label"
                  >{{ item.name }}<span class="rq-field">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  [id]="'attrInputField' + (i + 1)"
                  [(ngModel)]="item.value"
                  *ngIf="item.values.length == 0"
                  [placeholder]="formatPlaceHolders(item.name)"
                />
                <select
                  class="form-select"
                  *ngIf="item.values.length > 0"
                  [(ngModel)]="item.value"
                  [id]="'attrSelectField' + (i + 1)"
                >
                  <option [ngValue]="''" selected hidden>
                    Select {{ item.name }}
                  </option>
                  <option
                    *ngFor="let attrValItem of item.values"
                    [ngValue]="attrValItem"
                  >
                    {{ attrValItem }}
                  </option>
                </select>
              </div>
            </div>
            <div class="field-head mt-0">
              <h6 class="mb-0">Company Default Attributes</h6>
            </div>

            <div class="d-flex flex-wrap">
              <div
                *ngFor="let attribute of productAttributes"
                class="w-50 px-2 mb-4 company-attribute"
              >
                <label
                  [for]="'attribute-' + attribute.id"
                  class="form-label mb-0"
                >
                  {{ attribute.name
                  }}<span class="rq-field" *ngIf="attribute.isMandatory"
                    >*</span
                  >
                </label>

                <select
                  class="form-select"
                  [id]="'attribute-' + attribute.id"
                  aria-label="Default select example"
                  name="attribute.name"
                  required
                  [(ngModel)]="selectedAttributes[attribute.id]"
                  (change)="onAttributeSelected(attribute.id)"
                >
                  <option [ngValue]="null" hidden selected>
                    Select {{ attribute.name }}
                  </option>

                  <option
                    *ngFor="let item of attribute.productAttributeListItems"
                    [value]="item.id"
                  >
                    {{ item.value }}
                  </option>
                </select>
              </div>
            </div>
            <div class="field-head mt-0">
              <h6 class="mb-0">Dimension</h6>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div class="enter me-2">
                <label for="heightField" class="form-label"
                  >Height<span class="rq-field">*</span></label
                >
                <input
                  type="text"
                  min="0"
                  class="form-control"
                  [(ngModel)]="createProductRequest.height"
                  id="heightField"
                  placeholder="Enter height"
                  (keypress)="allowDecimal($event)"
                />
              </div>
              <div class="enter ms-2">
                <label for="widthField" class="form-label"
                  >Width<span class="rq-field">*</span></label
                >
                <input
                  type="text"
                  min="0"
                  class="form-control"
                  id="widthField"
                  [(ngModel)]="createProductRequest.width"
                  placeholder="Enter width"
                  (keypress)="allowDecimal($event)"
                />
              </div>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div class="enter me-2 mb-0">
                <label for="lengthField" class="form-label"
                  >Length<span class="rq-field">*</span></label
                >
                <input
                  type="text"
                  min="0"
                  class="form-control"
                  id="lengthField"
                  [(ngModel)]="createProductRequest.length"
                  placeholder="Enter length"
                  (keypress)="allowDecimal($event)"
                />
              </div>
              <div class="enter ms-2 mb-0">
                <label for="unitField" class="form-label"
                  >Unit<span class="rq-field">*</span></label
                >
                <select
                  class="form-select"
                  aria-label="Default select example"
                  id="unitField"
                  [(ngModel)]="createProductRequest.dimensionUnit"
                >
                  <option [ngValue]="0" hidden>Select unit</option>
                  <option
                    *ngFor="let item of dimensionUnitEnumList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="field-head">
              <h6 class="mb-0">Weight</h6>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div class="enter me-2 mb-0">
                <label for="weightField *" class="form-label"
                  >Weight<span class="rq-field">*</span></label
                >
                <input
                  type="text"
                  min="0"
                  class="form-control"
                  id="weightField"
                  [(ngModel)]="createProductRequest.weight"
                  placeholder="Enter weight"
                  (keypress)="allowDecimal($event)"
                />
              </div>
              <div class="enter ms-2 mb-0">
                <label for="unitFieldWt" class="form-label"
                  >Unit<span class="rq-field">*</span></label
                >
                <select
                  class="form-select"
                  aria-label="Default select example"
                  id="unitFieldWt"
                  [(ngModel)]="createProductRequest.weightUnit"
                >
                  <option [ngValue]="0" hidden>Select unit</option>
                  <option
                    *ngFor="let item of weightUnitEnumList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="field-head">
              <h6 class="mb-0">Shipping</h6>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div class="enter me-2">
                <label for="shippingUnitField" class="form-label"
                  >Shipment Box</label
                >
                <select
                  class="form-select"
                  aria-label="Default select example"
                  [(ngModel)]="
                    createProductRequest.listerProduct.defaultShipmentBoxId
                  "
                  id="shippingUnitField"
                >
                  <option [ngValue]="null" hidden>Select box</option>
                  <option
                    *ngFor="let item of shipmentBoxesList"
                    [ngValue]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="enter ms-2"></div>
            </div>
          </div>
        </div>
        <!-- Tab 4 Content -->
        <div
          class="tab tab-4 h-100"
          style="overflow-y: scroll"
          *ngIf="tabIndex == 4"
        >
          <div
            class="d-flex align-items-center"
            style="
              height: 80px;
              padding-top: 14px;
              position: sticky;
              top: 0;
              z-index: 10;
              background: #ffffff;
            "
          >
            <div class="tab-5-header tab-cm-header py-3">
              <h6>Add Images</h6>
            </div>
          </div>
          <div class="row mx-0">
            <div
              class="col-xl-6 ps-0"
              style="padding-top: 18px; padding-right: 9px"
            >
              <div class="sl-img-wrapper">
                <div
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <img src="../../../../../assets/Icons/select_img.svg" />
                  <h6>Drop Image</h6>
                  <p>or</p>
                  <button class="btn img-btn" (click)="browseProductImg()">
                    Upload from device
                  </button>
                  <input
                    class="d-none"
                    id="select_image"
                    #browseProductImgEle
                    type="file"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff"
                    (change)="getProductImgUrl($event)"
                  />
                </div>
              </div>
            </div>
            <div class="col-xl-6 px-0">
              <div class="imgs-wrapper">
                <div class="row mx-0">
                  <div
                    class="col-xl-4"
                    *ngFor="
                      let item of createProductRequest.productImages;
                      let i = index
                    "
                    style="padding: 18px 9px 0 9px"
                  >
                    <div
                      class="img-col-wrapper"
                      [style.backgroundColor]="item.url ? 'white' : '#F7F7F7'"
                    >
                      <img *ngIf="item.url" [src]="item.url" />
                      <div *ngIf="item.url" class="img-ac">
                        <button
                          type="button"
                          class="btn"
                          (click)="manageProductImageAction('primary', i)"
                        >
                          <img
                            *ngIf="item.isPrimary"
                            src="../../../../../assets/Icons/make_fav.svg"
                          />
                          <img
                            *ngIf="!item.isPrimary"
                            src="../../../../../assets/Icons/make_fav_dis.svg"
                          />
                        </button>
                        <button
                          type="button"
                          class="btn"
                          (click)="manageProductImageAction('delete', i)"
                        >
                          <img src="../../../../../assets/Icons/del_img.svg" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Tab 5 Content -->
        <div class="tab tab-5 h-100" *ngIf="tabIndex == 5">
          <div
            class="d-flex align-items-center"
            style="height: 80px; padding-right: 26px; padding-top: 14px"
          >
            <div class="tab-5-header tab-cm-header py-3">
              <h6>Review</h6>
            </div>
          </div>
          <div class="rw-tab-wrapper">
            <div
              class="d-flex align-items-center"
              style="height: 90px; padding-right: 29px; padding-left: 4px"
            >
              <ul class="nav nav-pills" id="product-tabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="tab-general-info"
                    data-bs-toggle="pill"
                    data-bs-target="#pane-general-info"
                    type="button"
                    role="tab"
                    aria-controls="pane-general-info"
                    aria-selected="true"
                  >
                    General information
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="tab-posting-profile"
                    data-bs-toggle="pill"
                    data-bs-target="#pane-posting-profile"
                    type="button"
                    role="tab"
                    aria-controls="pane-posting-profile"
                    aria-selected="false"
                  >
                    Posting profile
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="tab-physical-attributes"
                    data-bs-toggle="pill"
                    data-bs-target="#pane-physical-attributes"
                    type="button"
                    role="tab"
                    aria-controls="pane-physical-attributes"
                    aria-selected="false"
                  >
                    Physical attributes
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="tab-images"
                    data-bs-toggle="pill"
                    data-bs-target="#pane-images"
                    type="button"
                    role="tab"
                    aria-controls="pane-images"
                    aria-selected="false"
                  >
                    Images
                  </button>
                </li>
              </ul>
            </div>
            <!-- Tab Panes -->
            <div class="tab-content" id="product-tabs-content">
              <!-- General information review content -->
              <div
                class="tab-pane fade show active"
                id="pane-general-info"
                role="tabpanel"
                aria-labelledby="tab-general-info"
              >
                <div class="cm-grp">
                  <div class="row mx-0">
                    <div class="col-xl-6 cm-sm-col">
                      <label>Name</label>
                      <h6>
                        {{ createProductRequest.name }}
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Product Condition</label>
                      <h6>
                        <ng-container
                          *ngIf="
                            conditionEnumList?.length &&
                              createProductRequest.listerProduct.condition > 0;
                            else noCondition
                          "
                        >
                          {{
                            conditionEnumList[
                              createProductRequest.listerProduct.condition - 1
                            ].name
                          }}
                        </ng-container>

                        <ng-template #noCondition>
                          <span class="text-muted">No condition available</span>
                        </ng-template>
                      </h6>
                    </div>
                    <div class="col-12 cm-sm-col">
                      <label>Description</label>
                      <h6>
                        {{ createProductRequest.description || "-" }}
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Product Department</label>
                      <h6>
                        {{ getCategoryName(createProductRequest.categoryId) }}
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Brand</label>
                      <h6>{{ getBrandName(createProductRequest.brandId) }}</h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Model</label>
                      <h6>{{ createProductRequest.model }}</h6>
                    </div>
                    @if(createProductRequest.serialNumber){
                    <div class="col-xl-6 cm-sm-col">
                      <label>Serial Number</label>
                      <h6>{{ createProductRequest.serialNumber }}</h6>
                    </div>
                    }
                    <div class="col-xl-6 cm-sm-col">
                      <label>Product Department</label>
                      <h6>
                        {{
                          getDepartmentName(
                            createProductRequest.productDepartmentId
                          )
                        }}
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Supplier</label>
                      <h6>
                        {{ getSupplierName(createProductRequest.supplierId) }}
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Manufacturer</label>
                      <h6>{{ createProductRequest.manufacturer }}</h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Warehouse Location</label>
                      <h6>
                        {{
                          getWarehouseLocationName(
                            createProductRequest.warehouseLocationId
                          )
                        }}
                      </h6>
                    </div>
                    <div class="col-xl-6 cm-sm-col">
                      <label>Fragile</label>
                      <h6>
                        {{ createProductRequest.isFragile ? "Yes" : "No" }}
                      </h6>
                    </div>
                    <div class="col-12 cm-sm-col">
                      <label>Note</label>
                      <h6>{{ createProductRequest.notes }}</h6>
                    </div>
                    <div class="col-12 cm-sm-col">
                      <label>Posting Description</label>
                      <h6>
                        {{
                          createProductRequest.listerProduct.postingDescription
                        }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Posting profile review content -->
              <div
                class="tab-pane fade"
                id="pane-posting-profile"
                role="tabpanel"
                aria-labelledby="tab-posting-profile"
              >
                <div class="row profile-rules-wrapper mt-2">
                  <div class="col-lg-5 cm-col h-100">
                    <div class="col-wrapper h-100">
                      <div class="cm-section-header">
                        <h6 class="mb-0">Posting Profile</h6>
                        <h6 class="mb-0">
                          Status :
                          <span style="color: #0070b9">{{
                            postingProfile.statusName
                          }}</span>
                        </h6>
                      </div>
                      <div class="cm-grp">
                        <div class="row mx-0">
                          <div class="col-12 cm-sm-col">
                            <label>Name</label>
                            <h6>{{ postingProfile.name }}</h6>
                          </div>
                          <div class="col-12 cm-sm-col pb-5">
                            <label>Description</label>
                            <h6>
                              {{ postingProfile.description | slice : 0 : 60 }}
                              <span
                                *ngIf="postingProfile.description.length > 60"
                              >
                                ...
                              </span>
                            </h6>
                          </div>
                          <div class="col-xl-6 cm-sm-col">
                            <label>Repeat Posting Profile</label>
                            <h6>
                              {{ postingProfile.repeatNoOfTimesIfUnsold }}
                            </h6>
                          </div>
                          <div class="col-xl-6 cm-sm-col">
                            <label>Unpaid Auction Handling</label>
                            <h6>
                              {{ postingProfile.auctionPaymentDueOptionName }}
                            </h6>
                          </div>
                          <div class="col-xl-6 cm-sm-col">
                            <label>Handling Price</label>
                            <div>
                              {{ postingProfile.handlingCharges | currency }}
                            </div>
                          </div>
                          <div class="col-xl-6 cm-sm-col">
                            <label>End of Rule Auction</label>
                            <h6>
                              {{ postingProfile.endOfAuctionActionName }}
                            </h6>
                          </div>
                          <div
                            class="col-xl-6 cm-sm-col"
                            *ngIf="
                              postingProfile.endOfAuctionActionName ==
                              'Move to Sales Floor'
                            "
                          >
                            <label>Sales Floor Price</label>
                            <div>
                              {{ postingProfile.salesFloorPrice | currency }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7 cm-col h-100">
                    <div class="col-wrapper h-100">
                      <div class="cm-section-header">
                        <h6 class="mb-0">Posting Rules</h6>
                      </div>
                      <div class="accr-wrapper" id="rulesWrapperParent">
                        <div
                          class="ms-1 accordion mb-4"
                          [id]="'rule' + i + 1"
                          *ngFor="
                            let ruleItem of postingProfile.rules;
                            let i = index
                          "
                        >
                          <div class="accordion-item">
                            <h2
                              class="accordion-header"
                              [id]="'ruleHeader' + (i + 1)"
                            >
                              <button
                                class="accordion-button d-flex align-items-center"
                                type="button"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="
                                  '#collapseSelectRule' + (i + 1)
                                "
                                [attr.aria-controls]="
                                  'collapseSelectRule' + (i + 1)
                                "
                                aria-expanded="true"
                              >
                                <span>Rule {{ i + 1 }}</span>
                              </button>
                            </h2>
                            <div
                              [id]="'collapseSelectRule' + (i + 1)"
                              class="accordion-collapse collapse show"
                              [attr.aria-labelledby]="'ruleHeader' + (i + 1)"
                              data-bs-parent="#rulesWrapperParent"
                            >
                              <div class="pt-2 px-2">
                                <div class="cm-grp">
                                  <div class="row mx-0">
                                    <div class="col-12 cm-sm-col">
                                      <label>Rule Type</label>
                                      <h6>
                                        {{ ruleItem.typeName }}
                                      </h6>
                                    </div>
                                    <div class="col-xl-4 cm-sm-col">
                                      <label>Marketplace </label>
                                      <h6>
                                        {{ ruleItem.marketplaceName }}
                                      </h6>
                                    </div>
                                    <div class="col-xl-4 cm-sm-col">
                                      <label>Marketplace Account</label>
                                      <h6>
                                        {{ ruleItem.marketplaceAccount.name }}
                                      </h6>
                                    </div>

                                    <div class="col-xl-4 cm-sm-col">
                                      <label>Start</label>
                                      <h6>
                                        {{ ruleItem.auctionStartOptionName }}
                                      </h6>
                                    </div>
                                    <div class="col-xl-4 cm-sm-col">
                                      <label>Duration (in days)</label>
                                      <h6>
                                        {{ ruleItem.auctionDurationInDays }}
                                      </h6>
                                    </div>
                                    <div class="col-xl-4 cm-sm-col">
                                      <label for="carrierField">Carrier</label>
                                      <span class="d-block">
                                        {{
                                          getCarrierName(ruleItem.carrierId)
                                        }}</span
                                      >
                                    </div>
                                    <div
                                      class="col-xl-6 cm-sm-col"
                                      *ngIf="ruleItem.typeName == 'BuyNow'"
                                    >
                                      <label>Price</label>
                                      <div>
                                        {{ ruleItem.buyNowPrice | currency }}
                                      </div>
                                    </div>
                                    <div *ngIf="ruleItem.typeName == 'Auction'">
                                      <div class="col-xl-4 cm-sm-col">
                                        <label>Start Bid</label>
                                        <div>
                                          {{ ruleItem.startingBid | currency }}
                                        </div>
                                      </div>
                                      <div class="col-xl-4 cm-sm-col">
                                        <label>Bid Increment</label>
                                        <div>
                                          {{ ruleItem.bidIncrement | currency }}
                                        </div>
                                      </div>
                                      <div class="col-xl-4 cm-sm-col">
                                        <label>Reserve Price</label>
                                        <div>
                                          {{ ruleItem.reservePrice | currency }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Physical attributes review content -->
              <div
                class="tab-pane fade"
                id="pane-physical-attributes"
                role="tabpanel"
                aria-labelledby="tab-physical-attributes"
              >
                <div class="tab-3-fileds-wrapper">
                  <div
                    class="field-head mt-0"
                    *ngIf="createProductRequest.attributes.length > 0"
                  >
                    <h6 class="mb-0">Product</h6>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-6 enter w-50"
                      *ngFor="
                        let item of createProductRequest.attributes;
                        let i = index
                      "
                    >
                      <label class="form-label">
                        {{ item.name }}
                        <span class="rq-field">*</span>
                      </label>
                      <div>
                        {{ item.value || "-" }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="field-head mt-0"
                    *ngIf="
                      createProductRequest.listerProduct.marketplaceAttributes
                        .length > 0
                    "
                  >
                    <h6 class="mb-0">Marketplace</h6>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-6 enter w-50"
                      *ngFor="
                        let item of createProductRequest.listerProduct
                          .marketplaceAttributes;
                        let i = index
                      "
                    >
                      <label class="form-label">
                        {{ item.name }}
                        <span class="rq-field">*</span>
                      </label>
                      <div>
                        {{ item.value || "-" }}
                      </div>
                    </div>
                  </div>

                  <div class="field-head mt-0">
                    <h6 class="mb-0">Dimensions</h6>
                  </div>
                  <div
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <div class="enter me-2">
                      <label class="form-label"
                        >Height<span class="rq-field">*</span></label
                      >
                      <div>
                        {{ createProductRequest.height || "-" }}
                      </div>
                    </div>
                    <div class="enter ms-2">
                      <label class="form-label"
                        >Width<span class="rq-field">*</span></label
                      >
                      <div>
                        {{ createProductRequest.width || "-" }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <div class="enter me-2 mb-0">
                      <label class="form-label"
                        >Length<span class="rq-field">*</span></label
                      >
                      <div>
                        {{ createProductRequest.length || "-" }}
                      </div>
                    </div>
                    <div class="enter ms-2 mb-0">
                      <label class="form-label"
                        >Unit<span class="rq-field">*</span></label
                      >
                      <div>
                        {{
                          dimensionUnitEnumList[
                            createProductRequest.dimensionUnit - 1
                          ].name || "-"
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="field-head">
                    <h6 class="mb-0">Weight</h6>
                  </div>
                  <div
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <div class="enter me-2 mb-0">
                      <label class="form-label"
                        >Weight<span class="rq-field">*</span></label
                      >
                      <div>
                        {{ createProductRequest.weight || "-" }}
                      </div>
                    </div>
                    <div class="enter ms-2 mb-0">
                      <label class="form-label"
                        >Unit<span class="rq-field">*</span></label
                      >
                      <div>
                        {{
                          weightUnitEnumList[
                            createProductRequest.weightUnit - 1
                          ].name || "-"
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="field-head">
                    <h6 class="mb-0">Shipping</h6>
                  </div>
                  <div
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    <div class="enter me-2">
                      <label class="form-label">Shipment Box</label>
                      <div>
                        {{
                          getShipmentBoxName(
                            createProductRequest.listerProduct
                              .defaultShipmentBoxId
                          )
                        }}
                      </div>
                    </div>
                    <div class="enter ms-2"></div>
                  </div>
                </div>
              </div>
              <!-- Images review content -->
              <div
                class="tab-pane fade"
                id="pane-images"
                role="tabpanel"
                aria-labelledby="tab-images"
              >
                <div class="imgs-wrapper">
                  <div class="row mx-0">
                    <div
                      class="col-xl-3"
                      *ngFor="
                        let item of createProductRequest.productImages;
                        let i = index
                      "
                      style="padding: 18px 9px 0 9px"
                    >
                      <div
                        class="img-col-wrapper"
                        *ngIf="item.url"
                        [style.backgroundColor]="item.url ? 'white' : '#F7F7F7'"
                      >
                        <img [src]="item.url" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Tab 6 Content -->
        <div
          class="tab tab-5 h-100"
          style="padding-right: 26px"
          *ngIf="tabIndex == 6"
        >
          <div
            class="product-done"
            *ngIf="createUpdateAction.isAdded && !isActionLoading"
          >
            <div
              class="d-flex justify-content-center align-items-center w-100 h-100 overflow-auto"
            >
              <img
                class="img-fluid w-100 h-100"
                src="../../../../../assets/Icons/product_added_ic.svg"
              />
            </div>
            <h5 class="mb-1" style="font-weight: 600">
              Product {{ createProductRequest.id == 0 ? "Added" : "Updated" }}!
            </h5>
            <p style="color: #71727a; font-size: 14px">
              Yay ! You have
              {{
                createProductRequest.id == 0 ? "added new" : "updated existing"
              }}
              product successfully.
            </p>
          </div>
          <div
            class="d-flex justify-content-center align-items-center h-100 text-danger"
            *ngIf="!createUpdateAction.isAdded && !isActionLoading"
          >
            {{ createUpdateAction.actionStatusText }}
          </div>

          <div
            class="d-flex justify-content-center align-items-center h-100 pe-5"
          >
            <span class="loader"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="offcanvas-footer" [hidden]="tabIndex > 5">
  <button
    class="btn canvas-btn border-0"
    [style.color]="tabIndex == 1 ? '#8c8383' : '#0070B9'"
    [style.backgroundColor]="tabIndex == 1 ? '#1D1B201F' : '#E0F0FE'"
    [style.cursor]="tabIndex == 1 ? 'default' : 'pointer'"
    (click)="decrementTabIndex()"
  >
    Back
  </button>
  <button
    type="button"
    class="btn cnt-btn border-0"
    [disabled]="!validateProductActions()"
    (click)="incrementTabIndex()"
  >
    {{ tabIndex == 5 ? "Save" : "Continue" }}
  </button>
</div>
